module.exports = __webpack_public_path__ + "media/images/salespartner/flow-bc3eb76848ef2badc13532c47f2a7a22.svg";